{
  "activeDevicesInView": "Active Devices in View",
  "deviceProfileLinkText": "Manage",
  "controlPanelLinkText": "Controls",
  "automationDescription": {
    "notifyFalse": "When {{sourceDeviceName}}'s {{sourceSensor}} sensor changes from {{sourceSensorStatePrevious}} to {{sourceSensorStateCurrent}}, {{targetDeviceName}} should {{namedDeviceAction}}.",
    "notifyTrue": "When {{sourceDeviceName}}'s {{sourceSensor}} sensor changes from {{sourceSensorStatePrevious}} to {{sourceSensorStateCurrent}}, {{targetDeviceName}} should {{namedDeviceAction}} and send an sms notification."
  },
  "currentStatus": "Current Status",
  "deviceActivity": {
    "currentStatus": "Current Status",
    "linkTo": "Activity",
    "recentActivity": "Recent Activity",
    "title": "Device Activity"
  },
  "deviceInFieldWithFieldName": "In field {{fieldName}}",
  "deviceLocationUnknown": "Device location unknown",
  "deviceOffline": "Device offline",
  "deviceUnreachable": "Device Unreachable",
  "deviceUnreachableDescription": "Unable to reach this device after multiple attempts. Commands are paused until {{date}}.",
  "clearUnreachable": "Clear & Retry",
  "deviceErrorTimedOut": "Device took too long to respond.",
  "deviceErrorUnreachable": "Device could not be reached.",
  "deviceErrorDidNotRespond": "Device did not respond.",
  "deviceErrorReturnedFailure": "Device was unable to complete the request.",
  "deviceProfile": "Device Profile",
  "deviceRosterHelpContentBodyText": "All devices belonging to your farm are displayed in this list.\n\nClick/tap a device to view its device profile, where you can view and edit device configuration values, view device analytics, and more.",
  "deviceRosterHelpContentTitle": "Device Roster",
  "deviceRosterListEmpty": "Your farm account has no devices",
  "deviceRosterSortMenuTitle": "Sort Devices By",
  "deviceRosterTitle": "Devices",
  "deviceRosterTitleWithItemCount": "Devices ({{itemCount}})",
  "deviceSortKeys": {
    "alphabetical": "Device Name",
    "device_activity": "Activity",
    "device_installation_type": "Installation Type"
  },
  "eventsUpdated": "Events updated",
  "forceUpdate": "Refresh Data",
  "goToFieldProfile": "Go to Field Profile",
  "inFieldWithColon": "In field:",
  "locationWithColon": "Location:",
  "manageDeviceLinkText": "Manage",
  "openLocationNavigation": "Open location navigation options",
  "noActiveDevicesInView": "No active devices in view",
  "noCommandsFoundForDevice": "No commands found for this device",
  "noConnections": "No connections created for this device",
  "noEvents": "No activity detected from your farm`s devices. Check back later for new updates.",
  "noGps": "No GPS",
  "over24HoursAgo": "Over 24 Hours Ago",
  "pivotLegendArm": "Pivot arm (current position)",
  "pivotLegendEndGun": "End gun on",
  "pivotLegendLastKnown": "Last known position (stale)",
  "pivotLegendSweptArea": "Area swept this run",
  "pivotLegendTitle": "Map Legend",
  "pivotLegendWater": "Water on (wet)",
  "pivotNextStopWithVal": "Next: {{val}}",
  "pivotStale": "Stale",
  "pivotTimeToStopWithVal": "{{val}} to stop",
  "recentActivity": "Recent Activity",
  "reelSpeed": {
    "max": {
      "defaultValueHint": "A good place to set the maximum speed is 10x the typical retract speed.",
      "description": "If the reel's speed goes above the max speed, we will consider the reel to be extending."
    },
    "min": {
      "defaultValueHint": "A good place to set the minimum speed is 1/3 of the typical retract speed.",
      "description": "If the reel's speed goes below the min speed, we will consider the reel stopped and take any actions you've configured."
    }
  },
  "requestUpdateButton": "Request Update",
  "runComplete": "Run Complete",
  "runEtaWithTimestamp": "ETA: {{val, datetime}}",
  "runProgressFractionWithUnitLabel": "{{distanceElapsed}}/{{distanceMax}} {{unitLabel}}",
  "runStopped": "Stopped",
  "runStoppedShort": "Stopped Short",
  "sensorStateUnknownWithSensorName": "{{sensorName}} Unknown",
  "sensorStateWithSensorReading": "{{sensorState}} ({{sensorReading}})",
  "sensorStateWithSensorReadingAndUnitLabel": "{{sensorState}} ({{sensorReading}} {{unitLabel}})",
  "setCenterPivotPathCenterMarkerLabel": "Center",
  "setCenterPivotPathLinkTo": "Set Outline",
  "setCenterPivotPathNotSetWarning": "Center pivot outline not configured. Set an outline to enable center pivot tracking features.",
  "setCenterPivotPathSetCenterInstructions": "Tap the map to set the center pivot location",
  "setCenterPivotPathTitle": "Set Center Pivot Outline",
  "setPidSetpointFormDisclaimerAcknowledgement": "I acknowledge that I am responsible for the safety of the equipment and personnel when setting the VFD tracking speed.",
  "setPidSetpointFormDisclaimerBody": "This is an experimental feature. This feature will attempt to achieve and maintain the target pressure as quickly as possible by changing VFD speed setting automatically.",
  "setPidSetpointFormSetPointInputLabel": "Setpoint",
  "setPidSetpointFormSensorTypeLabel": "Setpoint Type",
  "setPidSetpointFormAdvancedLabel": "PID Settings (Advanced)",
  "setPidSetpointFormTitle": "Maintain Setpoint",
  "setVfdSpeedFormFrequencyLabel": "Speed (Percent)",
  "setVfdSpeedFormImmediateLabel": "Immediate",
  "setVfdSpeedFormInstructions": "Specify your desired percentage and ramp time.",
  "setVfdSpeedFormMinutesInputLabel": "Minutes",
  "setVfdSpeedFormRamp": "Ramp",
  "setVfdSpeedFormRampLabel": "Ramp",
  "setVfdSpeedFormRampTimeInstructions": "Ramp Time",
  "setVfdSpeedFormSecondsInputLabel": "Seconds",
  "setVfdSpeedFormTitle": "Set VFD Speed",
  "showAllDevices": "Show all devices",
  "title": "Device Status",
  "updateRequested": "Update Requested from Device...",
  "vfd": {
    "off": "VFD Off",
    "on": "VFD On",
    "over": "VFD Over",
    "ramping": "VFD Ramping",
    "title": "VFD",
    "trackingWithValue": "Tracking {{value}} {{unit}}",
    "under": "VFD Under"
  },
  "waitingForUpdate": "Waiting for update...",
  "pivotConfig": {
    "title": "Configure Pivot",
    "configureButton": "Configure Pivot",
    "name": "Name",
    "namePlaceholder": "Enter pivot name",
    "dimensionsSection": "Physical Dimensions",
    "pivotRadius": "Pivot Radius (m)",
    "radiusPlaceholder": "e.g., 400",
    "radiusHelper": "Main span radius from center to outer tower",
    "endGunThrow": "End Gun Throw (m)",
    "endGunThrowHelper": "Distance the end gun sprays beyond the main span",
    "noLocationSet": "Center location not set. Use the map builder to configure the pivot's location and boundaries.",
    "capabilitiesSection": "Capabilities",
    "hasDirectionControl": "Direction Control",
    "hasDirectionControlDesc": "Can control clockwise/counter-clockwise direction",
    "hasSpeedControl": "Speed Control",
    "hasSpeedControlDesc": "Can control pivot speed percentage",
    "hasEndGun": "End Gun",
    "hasEndGunDesc": "Has end gun installed",
    "hasWetDryControl": "Wet/Dry Control",
    "hasWetDryControlDesc": "Can toggle water on/off while moving",
    "speedByDepthSection": "Speed-by-Depth Calculation",
    "speedByDepthDescription": "These values are used to calculate application depth based on pivot speed.",
    "flowRate": "Average Flow Rate (L/min)",
    "flowRatePlaceholder": "e.g., 3000",
    "maxSpeedMph": "Max Tip Speed (m/h)",
    "maxSpeedMphPlaceholder": "e.g., 105",
    "maxSpeedMphHelper": "Tip linear speed at the controller's maximum (100%) setting",
    "minSpeedMph": "Min Tip Speed (m/h)",
    "minSpeedMphPlaceholder": "e.g., 10",
    "minSpeedMphHelper": "Tip linear speed at the slowest non-zero setting",
    "initialSpeedPercent": "Initial Speed (%)",
    "initialSpeedPercentPlaceholder": "e.g., 50",
    "initialSpeedPercentHelper": "Calibrated starting controller percent. The system adjusts up or down from here based on observed speed.",
    "linkedDevicesSection": "Linked Devices",
    "linkedDevicesHelper": "Device linking is managed through the device profile. Go to a device's profile to link or unlink it from this pivot.",
    "mapConfigSection": "Map Configuration",
    "mapConfigDescription": "Use the map builder to set the pivot center location and define boundaries.",
    "openMapBuilder": "Open Map Builder",
    "saveSuccess": "Pivot configuration saved",
    "validation": {
      "nameRequired": "Name is required",
      "radiusTooSmall": "Radius must be at least 10 meters",
      "endGunThrowNegative": "End gun throw cannot be negative",
      "endGunThrowTooLarge": "End gun throw cannot exceed 100 meters",
      "flowRatePositive": "Flow rate must be positive",
      "maxSpeedPositive": "Max tip speed must be positive",
      "minSpeedPositive": "Min tip speed must be positive",
      "minBelowMaxSpeed": "Min tip speed must be less than max tip speed",
      "initialSpeedPercentRange": "Initial speed must be between 0 and 100"
    }
  },
  "deviceAlias": "Device Alias"
}
